import { TooltipDesignTokens } from '@primeuix/themes/types/tooltip';

export const TOOLTIP_STYLES: TooltipDesignTokens = {
  root: {
    padding: '0.4375rem 0.625rem',
    maxWidth: '24rem',
  },

  css: () => `
    .p-tooltip-text {
      font-size: 0.875rem;
    }

    .white-tooltip .p-tooltip-text {
      background: var(--p-surface-0);
      color: var(--p-surface-800);
      border: 1px solid var(--p-surface-200);
      box-shadow: var(--p-shadow-sm);
    }

    .white-tooltip .p-tooltip-arrow {
      display: none;
    }

    .error-field-tooltip.p-tooltip-right {
      transform: translateX(1px);
    }

    .error-field-tooltip.p-tooltip-left {
      transform: translateX(-1px);
    }

    .error-field-tooltip.p-tooltip-top {
      transform: translateY(-1px);
    }

    .error-field-tooltip.p-tooltip-bottom {
      transform: translateY(1px);
    }`,
};
